import { I4BCellType, I4BColumnConfiguration } from './configurations/i4b-column-configuration';
import { getDefaultColumnsByConcept } from './default-columns.registry';
import { I4BEscalationProtocolsButtonColumn } from './definitions';
import { I4BBasicColumn } from './definitions/i4b-basic.column';
import { I4BColumn } from './definitions/i4b-column';
import { I4bCellConcept } from './enums';
import { EscalationProtocolsGridData } from './models';
import { HeaderType, I4BColumnHeader } from './models/i4b-column-header.model';
import { I4BGridOptions } from './models/i4b-grid-options.model';
import { I4BGrid } from './models/i4b-grid.model';
import { I4BColumnOptions } from './options/i4b-column-options';

export const GET_DEFAULT_ESCALATION_PROTOCOLS_COLUMNS_FOR_ESCALATION_PROTOCOLS_VIEW = (): I4BColumn<
  I4BColumnHeader,
  I4BColumnConfiguration,
  I4BColumnOptions
>[] => [
  new I4BBasicColumn(
    { displayName: 'NAME', type: HeaderType.BASIC },
    {
      id: 'name',
      isDefault: true,
      sortProperty: 'name',
      translationKey: 'IOT_DICTIONARY.NAME',
      concept: I4bCellConcept.ESCALATION_PROTOCOLS,
      isLink: true,
      cell: { type: I4BCellType.BASIC_LINK, event: { type: 'navigate' } }
    },
    { order: 1 }
  ),

  new I4BBasicColumn(
    { displayName: 'ENTITY', type: HeaderType.BASIC },
    {
      id: 'entity.name',
      isDefault: true,
      sortProperty: 'entity.name',
      translationKey: 'IOT_DICTIONARY.ENTITY',
      concept: I4bCellConcept.ESCALATION_PROTOCOLS,
      cell: { type: I4BCellType.BASIC }
    },
    { order: 2 }
  ),

  new I4BBasicColumn(
    { displayName: 'CREATED BY', type: HeaderType.BASIC },
    {
      id: 'createdBy',
      isDefault: true,
      sortProperty: 'createdBy',
      translationKey: 'IOT_DICTIONARY.CREATED_BY',
      concept: I4bCellConcept.ESCALATION_PROTOCOLS,
      cell: { type: I4BCellType.USER_CELL }
    },
    { order: 3 }
  ),
  new I4BBasicColumn(
    { displayName: 'CREATED AT', type: HeaderType.BASIC },
    {
      id: 'createdAt',
      isDefault: true,
      sortProperty: 'createdAt',
      translationKey: 'IOT_DICTIONARY.CREATED_AT',
      concept: I4bCellConcept.ESCALATION_PROTOCOLS,
      cell: { type: I4BCellType.DATE }
    },
    { order: 4 }
  ),
  new I4BBasicColumn(
    { displayName: 'EVALUATION MODE', type: HeaderType.BASIC },
    {
      id: 'evaluationMode',
      isDefault: true,
      sortProperty: 'evaluationMode',
      translationKey: 'IOT_DICTIONARY.EVALUATION_MODE',
      concept: I4bCellConcept.ESCALATION_PROTOCOLS,
      cell: { type: I4BCellType.TRANSLATED_CELL, options: { translateKey: 'IOT_DICTIONARY.' } }
    },
    { order: 5 }
  ),
  new I4BBasicColumn(
    { displayName: 'TOPIC SUBSCRIPTIONS', type: HeaderType.BASIC },
    {
      id: 'topics',
      isDefault: true,
      sortProperty: 'topics',
      translationKey: 'MASTER_VIEW_ENGINE.TABLE.HEADER_NAME.TOPIC_SUBSCRIPTIONS',
      concept: I4bCellConcept.ESCALATION_PROTOCOLS,
      cell: { type: I4BCellType.BASIC }
    },
    { order: 6 }
  )
];

export class DefaultEscalationProtocolsGrid implements I4BGrid<I4BGridOptions, EscalationProtocolsGridData> {
  masterview = 'escalation-protocols';
  isDefault = true;
  isUserDefault = true;
  isAppDefault = true;
  name = 'escalation-protocols';
  userId = '';
  data: EscalationProtocolsGridData = {
    response: {
      data: [],
      pagination: null
    }
  };
  gridOptions: I4BGridOptions = {
    pageSize: 100,
    multipleSelection: false,
    autoRefresh: { enabled: false },
    buttonColumn: { enabled: true, className: new I4BEscalationProtocolsButtonColumn() },
    gridSort: []
  };
  columns: I4BColumn<I4BColumnHeader, I4BColumnConfiguration, I4BColumnOptions>[] = [...getDefaultColumnsByConcept(this.masterview)];
}
